import React, { ReactNode, createContext, useContext, useState } from 'react'

type SurveyContextProps = {
  surveyCompleted: boolean
  setSurveyCompleted: (completed: boolean) => void
  shouldOpenSurvey: boolean
  setShouldOpenSurvey: (shouldOpen: boolean) => void
  phoneNumber: string
  setPhoneNumber: (phone: string) => void
}

const SurveyContext = createContext<SurveyContextProps | undefined>(undefined)

export const SurveyProvider = ({ children }: { children: ReactNode }) => {
  const [surveyCompleted, setSurveyCompleted] = useState(false)
  const [shouldOpenSurvey, setShouldOpenSurvey] = useState(false)
  const [phoneNumber, setPhoneNumber] = useState('')

  const contextValue: SurveyContextProps = {
    surveyCompleted,
    setSurveyCompleted,
    shouldOpenSurvey,
    setShouldOpenSurvey,
    phoneNumber,
    setPhoneNumber,
  }

  return <SurveyContext.Provider value={contextValue}>{children}</SurveyContext.Provider>
}

export const useSurveyContext = (): SurveyContextProps => {
  const context = useContext(SurveyContext)
  if (!context) {
    throw new Error('useSurveyContext must be used within a SurveyProvider')
  }
  return context
}
